import React from 'react'
import './collective.css'
import IMG1 from '../../assets/1setfull400x336.png'
import IMG2 from '../../assets/oa-logo.jpg'
import {FaTwitter} from 'react-icons/fa'
import {FaLink} from 'react-icons/fa'

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Set 1 x Fort Gotten',
    linktw: <a href="https://twitter.com/fortgotten" className="twitter__logo" target='_blank' rel="noreferrer"><FaTwitter/></a>,
    linkweb: <a href="https://www.fort-gotten.com/" className="twitter__logo" target='_blank' rel="noreferrer"><FaLink/></a>,
    description: 'Seven GX departed on a mission to explore the Fort Gotten planet.',
  },
  {
    id: 2,
    image: IMG2,
    title: 'Set 2 x DALL-E',
    linktw: <a href="https://twitter.com/openai" className="twitter__logo" target='_blank' rel="noreferrer"><FaTwitter/></a>,
    linkweb: <a href="https://openai.com/dall-e-2/" className="twitter__logo" target='_blank' rel="noreferrer"><FaLink/></a>,
    description: 'Eight GX generated by their owners using the AI system DALL-E.',
  },

]

const Collective = () => {
  return (
    <section id='collective'>
      <h5>Exploring</h5>
      <h2>GX Collective</h2>
      
      <div className="container portfolio__container">
        {
          data.map(({id, image, title, linktw, linkweb, description}) => {
            return (
              <article key={id} className='portfolio__item'>
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title} {linktw} {linkweb}</h3>
              <p className="p2">{description}</p>
            </article>   
            )
          })
        }
      </div>
      </section>
  )
}

export default Collective